import { Clients, RedirectUrls } from './oauthResource';
import transformError from '@/api/shared/transformers/errorTransformer';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';

function getClients({ packageName }) {
  return Clients.getClients({
    packageName,
  })
    .then(({ body }) => body.clients.map(item => transformToCamelCase(item)))
    .catch(transformError);
}

function getAllRedirectUrls(packageName) {
  return RedirectUrls.get({ packageName })
    .then(({ body: { redirect_urls = [] } = {} }) =>
      redirect_urls.map(transformToCamelCase),
    )
    .catch(transformError);
}

function addRedirectUrl({ packageName, url }) {
  return RedirectUrls.save({ packageName }, { url })
    .then(({ body: { redirect_url = {} } = {} }) =>
      transformToCamelCase(redirect_url),
    )
    .catch(transformError);
}

function removeRedirectUrl({ packageName, id }) {
  return RedirectUrls.remove({ packageName, id })
    .then(transformToCamelCase)
    .catch(transformError);
}

export default {
  getClients,
  getAllRedirectUrls,
  addRedirectUrl,
  removeRedirectUrl,
};
